module.exports = __webpack_public_path__ + "images/emoji/ram.3810ffaedb3d8054e09c.png";